//通用接口转发调用，区分get/post和获取object/array
// 以/v2/product/hint为例，POST /bowei/object?path=/v2/product/hint
//bowei/array get获取数组
//bowei/array post获取数组
//bowei/object get获取对象
//bowei/object post获取对象

import qs from 'qs'
import {setStore} from '../util/store'

let requestNew = null

export function setAxios(axios) {
	console.log('setAxios', '-----------')
	requestNew = axios
}

export function centerObjectGet(path, query = {}, headers = {}) {
	return requestNew({
		url: `/dist/bowei/object?path=${path}&contentType=application/json`,
		method: 'get',
		params: query,
		headers,
	})
}

export function centerObjectPost(path, data = {}) {
	return requestNew({
		url: `/dist/bowei/object?path=${path}`,
		method: 'post',
		data,
	})
}

/**---------------------**/

//投保提醒
export function getInsureHint(reqData) {
	return centerObjectPost('v2/product/hint', reqData)
}

//
// export function getInsureProfile(sourceProductId, productId, settingData = {}) {
//   let tempSetting = {
//     detailSign: 1,
//     // dutySign: 1,
//     protocolSign: 1,
//     pubInfoSign: 1,
//     settingSign: 1,
//     underwritingSign: 1
//   }
//   return centerObjectPost('v2/product/profile', {
//     productId,
//     sourceProductId,
//     ...tempSetting,
//     ...settingData
//   })
// }

export function getInsureProfile(questData) {
	let tempSetting = {
		detailSign: 1,
		// dutySign: 1,
		protocolSign: 1,
		pubInfoSign: 1,
		settingSign: 1,
		underwritingSign: 1,
	}
	return requestNew({
		url: `/dist/distProduct/v2/profile`,
		method: 'post',
		data: Object.assign(tempSetting, questData),
	})
}

//产品详情页--搜索接口
export function detailSearch(requestData) {
	return centerObjectPost('/v2/product/profile/search', requestData)
}

//获取投保配置项
export function getInsureBaseConfig(paramsData, headers = {}) {
	return requestNew({
		url: `/dist/bowei/object?path=/v2/insure/config`,
		method: 'post',
		headers,
		data: paramsData,
	})
}

export function getInsureEndorseBaseConfig(paramsData, headers = {}) {
	return requestNew({
		url: `/dist/bowei/object?path=/v2/endorse/add/config`,
		method: 'post',
		headers,
		data: paramsData,
	})
}

export function getInsureReplaceBaseConfig(paramsData, headers = {}) {
	return requestNew({
		url: `/dist/bowei/object?path=/v2/endorse/replace/config`,
		method: 'post',
		headers,
		data: paramsData,
	})
}

///v2/insure/batch_calc_apply 批量报价
export function getCalcPrice(requestData, isMore = false) {
	return centerObjectPost(!isMore ? '/v2/insure/calc_apply' : '/v2/insure/batch_calc_apply', requestData)
}

export function getCalcEndorsePrice(requestData) {
	return centerObjectPost('/v2/insure/calc_add', requestData)
}

// /v2/insure/batch_check 批量核保
export function getCalcPriceCheck(requestData, isMore = false) {
	return centerObjectPost(!isMore ? '/v2/insure/check' : '/v2/insure/batch_check', requestData)
}

//下单接口
export function getCreateInsure(requestData, headers = {}, isMore = false) {
	if (!isMore) {
		headers['content-type'] = 'application/x-www-form-urlencoded'
	}
	return requestNew({
		url: `${!isMore ? '/dist/distInsure/insure' : '/dist/bowei/object?path=/v2/insure/batch/create'}`,
		method: 'post',
		headers,
		data: !isMore ? qs.stringify(requestData) : requestData,
	})
}

export function getCalcEndorsePriceCheck(requestData) {
	return centerObjectPost('/v2/endorse/add/check', requestData)
}

export function getProductProtocol(requestData) {
	return centerObjectPost('/v2/product/protocol', requestData)
}

export function addIdNoQuery(queryId) {
	return centerObjectPost(`/service/batch/query/${queryId}`)
}

//产品列表
export function getProductListNew(paramsData = {}) {
	return centerObjectPost('/v2/index/main', paramsData)
}

//发票数据
export function getLastInvoice(requestData) {
	return centerObjectPost('/v2/insure/last_invoice', requestData)
}

//下载
export function handleDownCategoryFile(url, data, filename) {
	return handleDownCustom(url, data, filename, 'get')
}

//通过url 下载文件通用版
export function handleDownCustom(url, data, filename, method) {
	return requestNew({
		url: url,
		method: method,
		data,
		responseType: 'blob',
	}).then((response) => {
		// 处理返回的文件流
		const blob = response.data
		const link = document.createElement('a')
		link.href = URL.createObjectURL(blob)
		link.download = filename
		document.body.appendChild(link)
		link.click()
		window.setTimeout(function () {
			URL.revokeObjectURL(blob)
			document.body.removeChild(link)
		}, 0)
	})
}

/**
 * 获取提醒跳转
 */
export function getBrokerInfo(queryData) {
	return new Promise(async (resolve, reject) => {
		let {sourceProductId = '', productId = '', operate, changeScene = ''} = queryData
		if (!sourceProductId || !productId) {
			reject(new Error('投保参数不正确！'))
			return
		}
		//通过产品中心获取的提醒进行处理
		let tempData = await getInsureHint(queryData)
		let {code = -1, data = {}, msg = '获取投保提醒异常！'} = tempData.data || {}
		if (code === 0) {
			let {brokerInfo = {}} = data
			//获取投保跳转flag	是否切换域名（1：是 2：否）, host
			// host	主机域名
			setStore({name: 'brokerInfo', content: brokerInfo, type: 'session'})
			resolve(data)
		}
		reject(new Error(msg))
	})
}

/**
 * 获取config配置信息
 * @param isAdd
 * @param headers
 * @param productId
 * @param sourceProductId
 * @param orderId
 * @param getModeIds
 * @returns {Promise<unknown>}
 */
export function getBaseConfigInfo(isAdd, headers, productId, sourceProductId, orderId = '', getModeIds = {}) {
	return new Promise(async (resolve, reject) => {
		let baseQues = {
			productId,
			sourceProductId,
			orderInfo: {
				orderId,
			},
			...getModeIds,
		}
		let resConfig = !isAdd
			? await getInsureBaseConfig(baseQues, headers)
			: await getInsureEndorseBaseConfig(baseQues, headers)
		let {code = -1, data = {}, originMsg = '', msg = ''} = resConfig.data || {}
		if (code === 0) {
			//返回数据
			resolve(data)
		} else {
			reject(msg || originMsg || '获取配置异常，请稍后重试...')
		}
	})
}
